import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/basicMod/selectors/getVariationDraft";
import { getEmbeddedNodesFactory } from "@src/store/slices/experienceBuilder/common/selectors/getEmbeddedNodesFactory";
import { selectElement } from "@src/store/slices/experienceBuilder/basicMod/thunks/selectElement";
import { EmbeddedNodeType } from "@intelligems/ig-types/schemas/plugin/plugin/embedded";

export const swapDraft = createAsyncThunk<void, EmbeddedNodeType>(
  "experienceBuilder/swapDraft",
  (selector, { dispatch, getState }) => {
    const mod = getVariationDraft(getState());
    if (!mod || !("nodes" in mod)) {
      return;
    }

    const nodes = getEmbeddedNodesFactory(mod)(getState());
    const node = nodes.find((n) => n.selector === selector);
    if (!node) {
      return;
    }

    dispatch(selectElement({ nodes, node }));
  }
);
